import { Component, Input, forwardRef, ViewChild, Optional, Inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel, NG_ASYNC_VALIDATORS, NG_VALIDATORS } from '@angular/forms';
import { ElementBase } from '../base/element-base';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    }
  ]
})
export class InputNumberComponent extends ElementBase<number> {

  @Input()
  title: string;

  @Input()
  type = 'number';

  @Input()
  readonly = false;

  @Input()
  isShowIncrementButtons = true;

  @Input()
  step = 1;

  @Input()
  min: number;

  @Input()
  max: number;

  @Input()
  isTextCenter = true;

  faPlus = faPlus;
  faMinus = faMinus;

  @ViewChild(NgModel, {static: true}) model: NgModel;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  valueChanged(value) {
    const isSpaceValue = value.length > 0 && value.trim().length === 0;
    if (isSpaceValue) {
      this.model.control.setValue('');
      return;
    }
  }

  trimValue(value) {
    this.model.control.setValue(this.model.value.trim());
  }

  onClickCountChangeByOne(isUp: boolean): void {
    const oldValue = typeof (this.value) === 'string' ? parseInt(this.value) : this.value;;
    if (isNaN(oldValue)) {
      return this.model.control.setValue(this.min || 0);
    }

    const mathOperation = isUp ? 1 : -1;
    let newValue = oldValue + (this.step * mathOperation);
    if (this.min != null) {
      newValue = Math.max(this.min, newValue);
    }
    if (this.max != null) {
      newValue = Math.min(this.max, newValue);
    }

    this.model.control.setValue(newValue);
  }
}
